module.exports = __webpack_public_path__ + "img/logo.435a9fd7.svg";